module.exports = __webpack_public_path__ + "img/service_img12.123ad9fb.png";